import { writable, readable, derived } from 'svelte/store';
import { DateTime, Month, WeekDay } from './date-time';
const media = matchMedia('(max-width: 840px)');
const isMobile = readable(media.matches, set => media.addEventListener('change', e => set(e.matches)));
export class Calender {
    constructor(language, onShow) {
        this.language = language;
        this.onShow = onShow;
        this.firstDay = WeekDay.Monday;
        this.panelsCount = derived(isMobile, (mobile, set) => set(mobile ? 1 : 2));
        this.currentPanels = [];
        this.panels = writable(this.currentPanels);
        this.weekDays = new Array(7).fill(0).map((_, i) => ((this.firstDay + i) % 7));
    }
    get year() { return this.currentYear; }
    get month() { return this.currentMonth; }
    prevMonth() {
        const { year, month } = this.calcMonth(this.currentYear, this.currentMonth, -1);
        this.show(year, month);
    }
    nextMonth() {
        const { year, month } = this.calcMonth(this.currentYear, this.currentMonth, +1);
        this.show(year, month);
    }
    show(year, month) {
        var _a;
        if (this.currentYear == year && this.currentMonth == month) {
            return;
        }
        this.currentYear = year;
        this.currentMonth = month;
        (_a = this.current) === null || _a === void 0 ? void 0 : _a.call(null);
        this.current = this.panelsCount.subscribe(panelsCount => {
            const panels = [];
            for (let i = 0; i < panelsCount; i++) {
                const _ = this.calcMonth(year, month, i);
                panels.push({
                    month: _.month,
                    year: _.year,
                    weeks: [...this.getWeeks(_.month, _.year)],
                });
            }
            const from = new DateTime(panels[0].year, panels[0].month, 1);
            let to = new DateTime(panels[panels.length - 1].year, panels[panels.length - 1].month, 1);
            to = to.addDays(to.totalDaysInMonth - 1);
            this.onShow(from, to);
            this.currentPanels = panels;
            this.panels.set(panels);
        });
    }
    isVisible(year, month) {
        const isVisible = this.currentPanels.some(_ => _.year === year && _.month === month);
        return isVisible;
    }
    *getWeeks(month, year) {
        let days = [];
        for (const day of this.getDays(month, year)) {
            if (days.length === 7) {
                yield {
                    weekNumber: days[0].date.week,
                    days,
                };
                days = [];
            }
            days.push(day);
        }
        if (days.length) {
            yield {
                weekNumber: days[0].date.week,
                days,
            };
        }
    }
    *getDays(month, year) {
        const current = new DateTime(year, month, 1);
        const offsetDays = this.firstDay > current.weekDay
            ? this.firstDay - 7 - current.weekDay
            : this.firstDay - current.weekDay;
        const firstDay = current.addDays(offsetDays);
        const lastDay = current.addDays(current.totalDaysInMonth - 1);
        if (offsetDays) {
            const total1 = firstDay.totalDaysInMonth;
            for (let i = firstDay.day; i <= total1; i++) {
                const date = new DateTime(firstDay.year, firstDay.month, i);
                yield {
                    date,
                    lastMonth: true,
                };
            }
        }
        const total2 = lastDay.totalDaysInMonth;
        for (let i = current.day; i <= total2; i++) {
            const date = new DateTime(lastDay.year, lastDay.month, i);
            yield {
                date,
                lastMonth: false,
            };
        }
    }
    calcMonth(year, month, offset) {
        const date = new DateTime(year, month, 1).addMonths(offset);
        return {
            month: date.month,
            year: date.year
        };
    }
}
